import React, { Component } from 'react';
import { Form, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  columns = () => {
    return [
      {
        title: '终止合同编号',
        dataIndex: 'no',
        key: 'no',
        render: (text, record) => (
          <Link to={`/incubator/termination_manage/open/${record.uuid}`}>{text}</Link>
        ),
      },
      {
        title: '合同编号',
        dataIndex: 'businessNo',
        key: 'businessNo',
        render: (text, record) => (
          <Link to={`/incubator/termination_manage/open/${record.uuid}`}>{text}</Link>
        ),
      },
      {
        title: '客户',
        dataIndex: 'customName',
        key: 'customName',
        width: 200,
      },
      {
        title: '入驻园区',
        dataIndex: 'incubatorName',
        key: 'incubatorName',
        width: 200,
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          return <span>{moment.unix(text / 1000).format('YYYY-MM-DD')}</span>;
        },
      },
      {
        title: '当前环节',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          return <span>{currentActivity.name || ''}</span>;
        },
      },
      {
        title: '当前处理人',
        dataIndex: 'processorName',
        key: 'processorName',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          return <span>{currentActivity.processorName || ''}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '状态',
        dataIndex: 'long',
        render: (text, record) => {
          const instance = record.instance || {};
          let element;
          if (instance.status === 1) {
            element = <span style={{ color: 'red' }}>已完成</span>;
          } else {
            element = instance.currentActivity ? <span>处理中</span> : <span>待编辑</span>;
          }
          return element;
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      loading,
    } = this.props;
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        rowKey="uuid"
        loading={loading}
        onChange={this.handleChange}
      />
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/incubator/termination/TableSettled.js